export const companies = [
  {
    id: "3",
    name: "Vinscol",
    fullName: "Viação Nossa Senhora da Conceição",
    description: "A companhia Vinscol opera no transporte público dentro da cidade de Sabará-MG.",
    logo: "vinscol.svg"
  },
  {
    id: "4",
    name: "Transporte Coletivo Metropolitano",
    fullName: "Transporte Coletivo Metropolitano",
    description: "A companhia Transporte Coletivo Metropolitano - MG opera no transporte público da RMBH.",
    logo: "der-mg.png"
  },
];
